import { FC, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { routes } from "~/constants";
import { useCurrentUser } from "~/hooks/useCurrentUser";
import { usePartner } from "~/OnboardingApp/hooks";
import { useOnboarding } from "~/OnboardingApp/hooks/useOnboarding";

interface Props {
  children: ReactNode;
}

export const OnboardingSourceRedirector: FC<Props> = ({ children }) => {
  const onboarding = useOnboarding();
  const user = useCurrentUser();
  const { partnerSlug } = usePartner();
  const location = useLocation();
  const shouldGoToPartnerOnboarding = !!(
    user &&
    onboarding?.onboardingSource &&
    onboarding?.onboardingSource != partnerSlug
  );
  const shouldGoToDefaultOnboarding = !!(
    user &&
    !onboarding?.onboardingSource &&
    partnerSlug
  );

  if (shouldGoToPartnerOnboarding) {
    const partnerRoute = routes.partnerOnboardingRoot.replace(
      ":slug",
      onboarding.onboardingSource as string,
    );

    return <Navigate to={partnerRoute} state={location.state} />;
  }

  if (shouldGoToDefaultOnboarding) {
    return (
      <Navigate
        to={routes.onboardingRoot}
        state={{
          ...location.state,
          onboardingSource: partnerSlug,
        }}
      />
    );
  }

  return <>{children}</>;
};
